import { api } from '@/app'
import { CommunityComment, CommunityFeed } from '@/types'
import { useMutation, useQuery } from '@tanstack/react-query'
import { queryClient } from './queryClient'

export type ReportableContent =
  | {
      comment: CommunityComment['id']
    }
  | {
      feed_item: CommunityFeed['id']
    }
export type ReportContentData = ReportableContent & {
  reason: string
}

export const reportContent = async (content: ReportContentData) => {
  const response = await api.post('crm/report/', content)

  return response.data
}

const queryKey = queryClient.queryKey(['communityReports'])

async function retrieveCommunityReportOptions() {
  const response = await api.get<{ report_reason: { value: any; label: string }[] }>('/crm/options/')

  return response.data
}

export function useReport() {
  const mut = useMutation({
    mutationFn: reportContent,
  })

  return mut
}

export const useCommunityReportOptions = () => {
  return useQuery({
    queryKey: queryKey.key,
    queryFn: retrieveCommunityReportOptions,
    refetchOnMount(q) {
      return q.state.dataUpdateCount == 0
    },
  })
}
